import { useState, useEffect } from 'react';
import Header from '../../components/layout/Header';
import Body from '../../components/layout/Body';
import Table from '../../components/layout/Table';
import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useURLParams } from '../../contexts/ParamsContext';
import { useNotice } from '../../contexts/NoticeContext';

import {
    fetchGroups,
    deleteGroup,
} from '../../utils/api';

const GroupList = () => {
    const { params, updateUrlParams } = useURLParams();
    const { showNotice } = useNotice();
    const [fieldGroups, setFieldGroups] = useState([]);

    useEffect(() => {
        fetchGroups()
            .then(setFieldGroups)
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while fetching groups.'),
                    'error'
                );
            });
    }, []);

    const handledeleteGroup = (id) => {
        if (!confirm(__('Are you sure you want to delete this field group?', 'voxycure-framework'))) return;

        deleteGroup(id)
            .then(() => {
                setFieldGroups((prev) => prev.filter((group) => group.id !== id));
                showNotice(__('Group deleted successfully.', 'voxycure-framework'), 'success');
            })
            .catch((error) => {
                showNotice(
                    error?.message || __('Something went wrong while deleting group.'),
                    'error'
                );
            });
    };

    return (
        <>
            <Header>
                <h2 className="voxycure-editor__header-title">
                    {__('All Field Groups', 'voxycure-framework')}
                </h2>
                <Button
                    className="components-button is-primary voxycure-button"
                    onClick={() => updateUrlParams({ view: 'new-group' })}
                >
                    {__('Add New Group', 'voxycure-framework')}
                </Button>
            </Header>

            <Body>
                <Table
                    columns={[
                        { key: 'name', label: __('Group Name', 'voxycure-framework') },
                        { key: 'type', label: __('Type', 'voxycure-framework') },
                        { key: 'status', label: __('Status', 'voxycure-framework') },
                        { key: 'actions', label: __('Actions', 'voxycure-framework') },
                    ]}
                    data={fieldGroups}
                    emptyMessage={__('No groups found. Please try to create a new one.', 'voxycure-framework')}
                    renderRow={(group) => (
                        <tr key={group.id} style={{ borderBottom: '1px solid #eee' }}>
                            <td style={{ padding: '0.75rem' }}>{group.name}</td>
                            <td style={{ padding: '0.75rem' }}>
                                {group.type.charAt(0).toUpperCase() + group.type.slice(1)}
                            </td>
                            <td style={{ padding: '0.75rem' }}>
                                {group.status.charAt(0).toUpperCase() + group.status.slice(1)}
                            </td>
                            <td style={{ padding: '0.75rem' }}>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                        isSmall
                                        isSecondary
                                        onClick={() => updateUrlParams({ view: 'edit-group', id: group.id })}
                                    >
                                        {__('Edit', 'voxycure-framework')}
                                    </Button>
                                    <Button
                                        isSmall
                                        isDestructive
                                        onClick={() => handledeleteGroup(group.id)}
                                    >
                                        {__('Delete', 'voxycure-framework')}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    )}
                />
            </Body>
        </>
    );
};

export default GroupList;
